import BrandTagsContainer from './BrandTags.Container';

export default BrandTagsContainer;
